export const tr = {
    additions: 'Eklentiler: {additionsList}',
    'banner-has-template': 'Şablon kullanılıyor',
    id: 'No. {id}',
    info: '{bannerId}: {bannerHasTemplate}'
};
